import { ViewerDocumentKind, ViewerOpenContextKind, type ContentViewerSession, type ViewerDownloadTarget } from '@/content-viewer/store/schemas'

export type ContentViewerCapabilities = {
  downloadTarget: ViewerDownloadTarget | null
  canDownload: boolean
  canSaveToDrive: boolean
  canOpenInNewTab: boolean
}

export function getContentViewerCapabilities(session: ContentViewerSession | null): ContentViewerCapabilities {
  if (!session) {
    return {
      downloadTarget: null,
      canDownload: false,
      canSaveToDrive: false,
      canOpenInNewTab: false,
    }
  }

  const downloadTarget = session.document.downloadTarget ?? null

  return {
    downloadTarget,
    canDownload: Boolean(downloadTarget),
    canSaveToDrive: session.document.kind === ViewerDocumentKind.ARTIFACT,
    canOpenInNewTab: session.context.kind === ViewerOpenContextKind.CHAT_CITATION,
  }
}
